import React from 'react';
import { getWidthAndHeight } from './helpers';

export default function LogoIcon({ width, height, square=false, color="#0078FF" }) {
  const [svgWidth, svgHeight] = getWidthAndHeight({
    width,
    height,
    defaultWidth: square ? 64 : 58,
    defaultHeight: square ? 64 : 48,
    aspectRatio: square ? 1 : 1.20833333333
  });

  return (
  <svg width={svgWidth} height={svgHeight} viewBox={`0 0 ${svgWidth} ${svgHeight}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    { square ? (
      <g transform={`scale(${svgWidth / (square ? 64 : 58)})`}>
        <path d="M13 36.5516V58H17.7116V39.0475L23 36.111V31L13 36.5516Z" fill={color} />
        <path d="M38.0978 21L33 23.9386V29.2003L38.0978 26.2638L59.3201 38.4807V58H64V35.9101L38.0978 21Z" fill={color} />
        <path d="M9.19383 6L0 14.9377V58H4.75027V16.803L10.3717 11.3382L23 16.1248V11.2344L9.19383 6Z" fill={color} />
        <path d="M30.4549 53.6095V15.7393L26 14V18.7226V36.6652V58H54V53.6095H30.4549Z" fill={color} />
      </g>
    ) : (
      <g transform={`scale(${svgWidth / (square ? 64 : 58)})`}>
        <path d="M11.329 27.266V47.615H15.495V29.634L20.171 26.848V21.999L11.329 27.266Z" fill={color} />
        <path d="M34.384 13.531L29.846 16.238V21.085L34.384 18.38L53.276 29.634V47.615H57.442V27.266L34.384 13.531Z" fill={color} />
        <path d="M8.06299 0L0 8.18399V47.615H4.16599V9.892L9.09601 4.888L20.171 9.271V4.793L8.06299 0Z" fill={color} />
        <path d="M27.073 43.45V7.52499L22.908 5.875V10.355V27.376V47.615H49.086V43.45H27.073Z" fill={color} />
      </g>
    )}
  </svg>
  );
}



// WEBPACK FOOTER //
// app/components/Logo/LogoIcon.jsx